import React, { useEffect, useState } from 'react';

import ReportBudgetRisksOpportunitiesIndexTableRow from './ReportBudgetRisksOpportunitiesIndexTableRow';

import { formatFigure } from 'Helpers/formatService';

import Button from 'CommonComponents/Button';
import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';
import TableSearchInput from 'CommonComponents/TableSearchInput';

export default function ReportBudgetRisksOpportunitiesIndexTable(props) {
    const [budgetRisksOpportunities, setBudgetRisksOpportunities] = useState([]);
    const [perPage, setPerPage] = useState(20);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isLoading, setIsLoading] = useState({});
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        fetchBudgetRisksOpportunities();
    }, []);

    const defaultUrl = props.reportBudgetRisksOpportunitiesIndexUrl + '?per_page=' + perPage;

    const combineFetchUrl = (p = null, pp = null) => {
        return (
            props.reportBudgetRisksOpportunitiesIndexUrl +
            '?per_page=' +
            (pp || perPage) +
            '&page=' +
            (p || page) +
            (searchValue.length > 0 ? '&search=' + searchValue : '')
        );
    };

    const fetchBudgetRisksOpportunities = (url = null) => {
        setIsLoading(true);
        const fetchUrl = url || defaultUrl;

        axios
            .get(fetchUrl)
            .then(({ data }) => {
                const { to, from, total, last_page } = data.meta;
                setBudgetRisksOpportunities(data.data);
                setTo(to);
                setFrom(from);
                setTotal(total);
                setLastPage(last_page);
                setIsLoading(false);
                setTotalAmount(data.meta.total_amount);
            })
            .catch((error) => {
                setBudgetRisksOpportunities([]);
                setIsLoading(false);
            });
    };

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchBudgetRisksOpportunities(url);
    }

    const handleChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            const url = combineFetchUrl(1);
            setPage(1);
            fetchBudgetRisksOpportunities(url);
            event.preventDefault();
        }
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-end tw-justify-between tw-mb-6">
                <div>
                    <h5 className="table__header">{$t('Budget Risks and Opportunities Report')}</h5>
                    <div className="table__pagination-info">
                        <PaginationInfo to={to} from={from} total={total} />
                        <TablePagination lastPage={lastPage} pageChange={pageChange} />
                    </div>
                </div>
                <div className="tw-flex tw-gap-x-1.5">
                    <TableSearchInput searchValue={searchValue} handleChange={handleChange} handleKeyPress={handleKeyPress} />
                    <Button type="submit" variant="primary" onClick={() => (window.location.href = props.reportBudgetRisksOpportunitiesExportUrl)}>
                        {$t('Generate Report')}
                    </Button>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table tw-table-fixed">
                    <thead>
                        <tr>
                            <th className="tw-w-20">{$t('Type')}</th>
                            <th className="tw-w-40">{$t('Name')}</th>
                            <th className="tw-w-80">{$t('Description')}</th>
                            <th className="tw-w-20">{$t('Include in Forecast')}</th>
                            <th className="tw-w-20">{$t('Amount')}</th>
                            <th className="tw-w-40">{$t('Department')}</th>
                            <th className="tw-w-40">{$t('Budget Line')}</th>
                        </tr>
                    </thead>
                    {!isLoading && budgetRisksOpportunities.length > 0 && (
                        <tbody>
                            {budgetRisksOpportunities.map((budgetRiskOpportunity) => {
                                return (
                                    <ReportBudgetRisksOpportunitiesIndexTableRow key={budgetRiskOpportunity.id} budgetRiskOpportunity={budgetRiskOpportunity} />
                                );
                            })}
                        </tbody>
                    )}
                    {isLoading && (
                        <tbody>
                            <tr>
                                <td colSpan="7">{$t('Loading...')}...</td>
                            </tr>
                        </tbody>
                    )}
                    {!isLoading && budgetRisksOpportunities.length === 0 && (
                        <tbody>
                            <tr>
                                <td colSpan="7">
                                    {$t(
                                        "No risks or opportunities found, you can add risks and opportunities by clicking the 'Add Risk/Opportunity' button at any department or cost centre.",
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    )}
                    {!isLoading && (
                        <tfoot>
                            <tr className="tw-font-semibold">
                                <td>{$t('Total')}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="inbud-numeric-cell">{formatFigure(totalAmount)}</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
        </div>
    );
}
